'use strict';

const VueRenderer = require('client/src/renderers/vue-renderer');
const InputViewComponent = require('../views/input-view/input-view.vue').default;

const InputViewRenderer = function (dependencies) {
	VueRenderer.call(this, dependencies);
};
InputViewRenderer.viewType = 'InputView';
InputViewRenderer.prototype = Object.create(VueRenderer.prototype);

InputViewRenderer.prototype.getVueComponent = function() {
	return InputViewComponent;
};
// InputViewRenderer.prototype.initVueComponent = function(component) {
// 	this.setComponentProps({
// 		contextMenus: this.getContextMenuData()
// 	});
// 	component.$on('context', (menu, item, target) => {
// 		this.triggerContextMenuItem(item, target);
// 	});
// };

module.exports = InputViewRenderer;

